import request from '@/utils/zsm-requets'
let douyin='/zsm/api/user/douyin/'
/**
 *  获取抖音基本信息
 */
export function getDouyinInfo(id) {
  return request({
    url: douyin+'get',
    method: 'post',
    params: {id}
  })
}
